// extracted by mini-css-extract-plugin
export var infoItem = "_nv-2";
export var title = "_nv-0";
export var value = "_nv-1";